import moment from "moment";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { DatePicker } from "rsuite";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Spinner } from "reactstrap";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import ErrorMessage from "../../../components/comman/ErrorMessage";
import BackArrowIcon from "../../../components/Icons/BackArrowIcon";
import DeleteIcon from "../../../components/Icons/DeleteIcon";
import PlusIcon from "../../../components/Icons/PlusIcon";
import UploadPlusIcon from "../../../components/Icons/UploadPlusIcon";
import { formatAmount } from "../../../utility/CommonFunctions";
import calculateFinancialYears, { getCurrentFinancialYear } from "../../../utility/CommonFunctions";
import { errorTypes } from "../../../utility/InputValidation";
import ViewDocumentModal from "../../Sites/ViewDocumentModal";
import SearchSelectInput from "../../../components/comman/SearchSelectInput";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

// Default state for a new, blank item
const createNewItem = () => ({
  itemId: "",
  name: "",
  hsnCode: "",
  quantity: "",
  availableQty: 0,
  unit: "unit",
  rate: "",
  gst: "",
  taxableAmount: 0,
  enteredTaxableAmount: "",
});

export default function CreateGeneral() {
  const [isLoading, setIsLoading] = useState(false);
  const userDetails = useSelector((state) => state.root.userDetails);
  const navigate = useNavigate();
  const location = useLocation();
  const EditData = location?.state?.data;
  // console.log("EditData====>",EditData);
  const [existingDocuments, setExistingDocuments] = useState([]);
  const [selectedDocument, setSelectedDocument] = useState();
  const [modal, setModal] = useState(false);
  const toggleModal = () => {
    setModal(!modal);
  };
  const [files, setFiles] = useState([]);

  // Financial Year State
  const [financialYears, setFinancialYears] = useState([]);
  const [activeFinancialYear, setActiveFinancialYear] = useState("");

  // State for the new UI
  const [expenseHeadList, setExpenseHeadList] = useState([]); // Master list of available heads
  const [selectedExpenseHead, setSelectedExpenseHead] = useState(null); // { id, name }
  const [items, setItems] = useState([]); // List of items for the selected head
  const [itemsList, setItemsList] = useState([]); // List of available items for the selected head
  const [isExpenseListLoading, setIsExpenseListLoading] = useState(false);
  const [isLoadingBankData, setIsLoadingBankData] = useState(false);

  const [state, setState] = useState({
    expenseLoading: false,
    OandMSites: [],
    projectSites: [],
    assignedSites: [],
    siteId: "",
    siteName: "",
    isLoadingSite: false,
    gstType: "",
    paymentTicketDetail: [],
  });

  const handleFinancialYearCalculation = (site) => {
    let date = new Date();
    if (site?.startDate) {
      date = new Date(site?.startDate);
    }
    const years = calculateFinancialYears(date, site?.endDate);
    setFinancialYears(years);

    if (years.length > 0) {
      const currentMonth = new Date().getMonth() + 1; // 1-12
      const currentYear = new Date().getFullYear();
      let defaultYear;

      if (currentMonth >= 4) {
        defaultYear = `${currentYear}-${currentYear + 1}`;
      } else {
        defaultYear = `${currentYear - 1}-${currentYear}`;
      }

      if (years.includes(defaultYear)) {
        setActiveFinancialYear(defaultYear);
        setValue("financialYear", defaultYear);
      } else {
        setActiveFinancialYear(years[years.length - 1]);
        setValue("financialYear", years[years.length - 1]);
      }
    } else {
      const currentFY = getCurrentFinancialYear();
      setFinancialYears([currentFY]);
      setActiveFinancialYear(currentFY);
      setValue("financialYear", currentFY);
    }
  };


  const {
    register,
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { errors },
    control,
    clearErrors,
  } = useForm();

  const fetchBankDetails = async (ifsc) => {
    if (ifsc && ifsc.length === 11) {
      setIsLoadingBankData(true);
      try {
        const response = await fetch(`https://ifsc.razorpay.com/${ifsc}`);
        if (response.ok) {
          const data = await response.json();
          setValue("bankName", data.BANK || "");
          setValue("branchName", data.BRANCH || "");
        } else {
          toast.error("Invalid IFSC Code");
        }
      } catch (error) {
        console.error("Error fetching bank details:", error);
      } finally {
        setIsLoadingBankData(false);
      }
    } else {
      setIsLoadingBankData(false);
    }
  };

  useEffect(() => {
    if (
      userDetails?.type === 2 &&
      (state?.OandMSites.length === 0 || state?.assignedSites.length === 0)
    ) {
      GetAllSitesList();
    } else if (
      state?.OandMSites.length === 0 ||
      state?.assignedSites.length === 0
    ) {
      getAssignedSites();
    }
  }, [userDetails?.type]);

  useEffect(() => {
    if (EditData) {
      let options = {
        method: "GET",
      };
      let API =
        apiUrl?.get_payment_ticket_details +
        `paymentTicketId=${location?.state?.data?.id}`;
      setState((prev) => ({
        ...prev,
        ptDataLoading: true,
      }));
      callApi(API, options).then((response) => {
        setState((prev) => ({
          ...prev,
          ptDataLoading: false,
        }));
        if (response?.status === true) {
          // console.log("res", response?.data);
          setState((prev) => ({
            ...prev,
            paymentTicketDetail: response?.data,
          }));
        }
      });
    }
  }, [EditData, location?.state?.data?.id]);

  // Effect to populate form when editing
  useEffect(() => {
    if (location?.state?.data && state?.paymentTicketDetail) {
      const paymentTicket = state.paymentTicketDetail;
      const firstExpenseHead = paymentTicket?.paymentticketexpenseheads?.[0];

      if (firstExpenseHead) {
        // Set the selected head
        setSelectedExpenseHead({
          id: firstExpenseHead?.expenseHeadId,
          name: firstExpenseHead?.expensehead?.name,
        });

        // Restore the items
        const restoredItems = firstExpenseHead?.paymentticketitems?.map(
          (item) => {
            const actualRate = item?.rate || item?.unitRate || 0;
            return {
              itemId: item?.itemId,
              name: item?.item?.name,
              quantity: item?.quantity,
              rate: actualRate,
              gst: item?.gst,
              taxableAmount: (parseFloat(item?.taxableAmount || 0) * (1 + (parseFloat(item?.gst) || 0) / 100)).toFixed(2),
              enteredTaxableAmount: parseFloat(item?.taxableAmount || 0).toFixed(2),
              hsnCode: item?.item?.hsnCode,
              unit: item?.item?.unit || "unit",
              availableQty: item?.quantity,
            };
          }
        );
        setItems(restoredItems || []);
      }

      setState((pre) => ({
        ...pre,
        siteId: paymentTicket?.site?.id,
        siteName: paymentTicket?.site?.name,
        gstType: paymentTicket?.gstType,
      }));
      // Calculating Financial Year on Edit
      if (paymentTicket?.site) {
        handleFinancialYearCalculation(paymentTicket?.site);
      }
      if (paymentTicket?.financialYear) {
        setActiveFinancialYear(paymentTicket?.financialYear);
        setValue("financialYear", paymentTicket?.financialYear);
      }

      setValue("gstType", paymentTicket?.gstType);
      setValue("content", paymentTicket?.description || "");
      setValue("name", paymentTicket?.beneficiaryName || paymentTicket?.vendor?.name || paymentTicket?.vendor?.firmName || "");
      setValue("phone", paymentTicket?.phone || paymentTicket?.vendor?.phone);
      setValue("bankName", paymentTicket?.bankName || paymentTicket?.vendor?.bankName);
      setValue("ifscCode", paymentTicket?.ifscCode || paymentTicket?.vendor?.ifscCode);
      setValue("accountHolderName", paymentTicket?.accountHolderName || paymentTicket?.vendor?.accountHolderName);
      setValue("accountNumber", paymentTicket?.accountNumber || paymentTicket?.vendor?.accountNumber);
      setValue("branchName", paymentTicket?.branchName || paymentTicket?.branchAddress || paymentTicket?.vendor?.branchName);
      setValue("siteId", paymentTicket?.site?.id);
      setValue("date", moment(paymentTicket?.date).format("YYYY-MM-DD"));
      setValue("expenseMonth", paymentTicket?.expenseMonth || "");

      if (paymentTicket?.documents?.length > 0) {
        setExistingDocuments(paymentTicket?.documents);
      }
    }
  }, [state?.paymentTicketDetail, location?.state?.data, setValue]);

  // Effect to fetch expense heads once siteId is set
  useEffect(() => {
    if (state.siteId && activeFinancialYear) {
      fetchExpenseHeadList();
    } else {
      setExpenseHeadList([]); // Clear list if no site
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.siteId, activeFinancialYear]);

  // Effect to populate itemsList when expenseHeadList loads (for edit mode)
  useEffect(() => {
    if (
      location?.state?.data &&
      selectedExpenseHead &&
      expenseHeadList.length > 0
    ) {
      const matchingHead = expenseHeadList.find(
        (h) => h?.expensehead?.id === selectedExpenseHead.id
      );
      if (matchingHead) {
        let options = { method: "GET" };
        callApi(apiUrl.get_items + `all=true`, options).then((res) => {
          if (res?.status === true) {
            const fetchedItems = res?.data?.item || res?.data || [];
            const mappedItems = fetchedItems.map(item => ({
              itemId: item.id,
              item: item,
              unitRate: item.rate || 0,
              gst: item.gst || 0
            }));
            setItemsList(mappedItems);
          }
        });

        // Use items from site budget directly without budget quantity limits
        setItems((prevItems) =>
          prevItems.map((item) => {
            const masterItem = matchingHead?.sitebudgetitems?.find(
              (m) => m?.itemId === item.itemId
            );
            if (masterItem) {
              return {
                ...item,
              };
            }
            return item;
          })
        );
      }
    }
  }, [expenseHeadList, selectedExpenseHead, location?.state?.data]);

  const getAssignedSites = (inputValue = null) => {
    const option = {
      method: "GET",
    };
    setState((prev) => ({
      ...prev,
      isLoadingSite: true,
    }));
    const url = `${apiUrl?.get_user_site}${inputValue ? `?search=${inputValue}` : ""
      }`;
    callApi(url, option).then((res) => {
      setState((prev) => ({
        ...prev,
        isLoadingSite: false,
      }));
      if (res?.status === true) {
        setState((prev) => ({
          ...prev,
          assignedSites: res?.data?.site?.map((item) => ({
            ...item,
            label: item?.site?.name,
            value: item?.site?.id,
          })),
        }));
      } else {
        toast.error(res?.message);
      }
    });
  };

  const GetAllSitesList = (inputValue = null) => {
    setState((prev) => ({
      ...prev,
      isLoadingSite: true,
    }));
    let options = {
      method: "GET",
    };
    let API =
      apiUrl.get_site +
      `?type=site${inputValue ? `&search=${inputValue}` : ""}`;
    callApi(API, options).then((response) => {
      setState((prev) => ({
        ...prev,
        isLoadingSite: false,
      }));
      if (response?.status === true) {
        setState((prev) => ({
          ...prev,
          OandMSites: response?.data?.site
            ?.filter((item) => item?.type === "O&M")
            ?.map((item) => ({
              ...item,
              label: item?.site?.name,
              value: item?.site?.id,
            })),
          projectSites: response?.data?.site
            ?.filter((item) => item?.type === "project")
            ?.map((item) => ({
              ...item,
              label: item?.site?.name,
              value: item?.site?.id,
            })),
        }));
      }
    });
  };

  const fetchExpenseHeadList = () => {
    return new Promise((resolve) => {
      const siteName = state?.siteId || "";
      if (!siteName || !activeFinancialYear) {
        resolve([]);
        return;
      }
      let API = `${apiUrl?.get_site_budget}type=generalBudget&from=General&siteId=${siteName}&financialYear=${activeFinancialYear}`;
      let options = { method: "GET" };

      setIsExpenseListLoading(true);

      callApi(API, options)
        .then((response) => {
          setIsExpenseListLoading(false);
          if (response?.status) {
            setExpenseHeadList(response?.data || []);
            resolve(response?.data || []);
          } else {
            resolve([]);
          }
        })
        .catch(() => {
          setIsExpenseListLoading(false);
          resolve([]);
        });
    });
  };

  const onSubmit = (data) => {
    // Validate that at least one item exists
    if (items.length === 0) {
      return toast.info("Please add at least one material item");
    }

    // Validate that an expense head was selected
    if (!selectedExpenseHead) {
      return toast.error("Please select an Expense Head");
    }

    // Validate that all added items have quantity and rate
    for (const item of items) {
      if (!item.quantity || parseFloat(item.quantity) <= 0) {
        return toast.error(`Please enter a valid quantity for ${item.name}`);
      }
      if (!item.rate || parseFloat(item.rate) <= 0) {
        return toast.error(`Please enter a valid rate for ${item.name}`);
      }
    }

    const grandTotal = parseFloat(calculateGrandTotal()?.toFixed(2));

    const totalTaxable = items.reduce((sum, item) => sum + parseFloat(item.enteredTaxableAmount || 0), 0);
    const totalGst = grandTotal - totalTaxable;

    const paymentTicketExpenseHead = [
      {
        expenseHeadId: selectedExpenseHead.id,
        name: selectedExpenseHead.name,
        amount: grandTotal,
        gst: totalGst.toFixed(2),
        taxableAmount: totalTaxable.toFixed(2),
        paymentTicketItem: items.map((item) => ({
          itemId: item.itemId,
          name: item.name,
          quantity: item.quantity,
          unit: item.unit,
          rate: item.rate,
          gst: item.gst || 0,
          taxableAmount: item.enteredTaxableAmount,
          amount: item.taxableAmount,
        })),
      },
    ];

    const postData = {
      type: "General",
      date: data?.date,
      expenseMonth: data?.expenseMonth,
      siteId: state?.siteId,
      totalAmount: grandTotal,
      gstType: data?.gstType,
      description: data?.content,
      paymentTicketExpenseHead: JSON.stringify(paymentTicketExpenseHead),
      beneficiaryDetails: JSON.stringify({
        ...(EditData?.vendor?.id && { id: EditData?.vendor?.id }),
        name: data?.name,
        phone: data?.phone,
        bankName: data?.bankName,
        ifscCode: data?.ifscCode,
        accountHolderName: data?.accountHolderName,
        accountNumber: data?.accountNumber,
        branchName: data?.branchName,
      }),
      financialYear: activeFinancialYear,
      bankName: data?.bankName,
      accountHolderName: data?.accountHolderName,
      accountNumber: data?.accountNumber,
      ifscCode: data?.ifscCode,
      branchName: data?.branchName,
      beneficiaryName: data?.name,
      phone: data?.phone,
    };

    const formData = new FormData();
    Object.keys(postData).forEach((key) => {
      const value = postData[key];
      if (value) {
        formData.append(key, value);
      }
    });

    if (files?.length > 0) {
      files.forEach((fileObj) => {
        formData.append(fileObj?.file?.name, fileObj.file);
      });
    }

    const option = {
      method: "POST",
      form_data: formData,
    };
    setIsLoading(true);
    const url = EditData
      ? apiUrl?.update_payment_ticket + `?paymentTicketId=${EditData?.id}`
      : apiUrl?.create_payment_ticket;
    callApi(url, option).then((res) => {
      setIsLoading(false);
      if (res?.status) {
        toast.success(res?.message);
        navigate(-1);
      } else {
        toast.error(res?.message);
      }
    });
  };

  // --- Handlers for the new dynamic UI ---

  // Handle changing the Expense Head dropdown for a section
  const handleExpenseHeadChange = (e) => {
    const newExpenseHeadId = e.target.value;
    const selectedHead = expenseHeadList.find(
      (head) => head?.expensehead?.id === newExpenseHeadId
    );

    if (selectedHead) {
      setSelectedExpenseHead({
        id: selectedHead.expensehead.id,
        name: selectedHead.expensehead.name,
      });

      // Clear existing items immediately to show it's loading/changed
      setItemsList([]);
      setItems([]);

      let options = { method: "GET" };
      callApi(apiUrl.get_items + `all=true`, options).then((res) => {
        if (res?.status === true) {
          const fetchedItems = res?.data?.item || res?.data || [];
          const mappedItems = fetchedItems.map(item => ({
            itemId: item.id,
            item: item,
            unitRate: item.rate || 0,
            gst: item.gst || 0
          }));
          setItemsList(mappedItems);
          // Items table stays empty until user clicks "Add Items"
        } else {
          setItemsList([]);
        }
      }).catch(() => {
        setItemsList([]);
      });
    }
  };

  // Add a new blank item row to a specific section
  const addItem = () => {
    setItems((prev) => [...prev, createNewItem()]);
  };

  // Remove an item row from a specific section
  const removeItem = (itemIndex) => {
    setItems((prev) => prev.filter((_, j) => j !== itemIndex));
  };

  // Handle changes to an item's fields (dropdown or quantity/rate/gst/taxableAmount)
  const handleItemChange = (itemIndex, field, value) => {
    setItems((prev) =>
      prev.map((item, j) => {
        if (j === itemIndex) {
          let updatedItem = { ...item };

          if (field === "itemId") {
            const fullItem = itemsList.find((i) => i?.itemId === value);

            updatedItem = {
              ...item,
              itemId: value,
              name: fullItem?.item?.name || "",
              hsnCode: fullItem?.item?.hsnCode || "--",
              unit: fullItem?.item?.unit || "unit",
              // Reset calculation fields
              quantity: "",
              rate: fullItem?.unitRate && parseFloat(fullItem?.unitRate) !== 0 ? parseFloat(fullItem?.unitRate).toFixed(2) : "",
              gst: parseFloat(fullItem?.gst || 0),
              taxableAmount: 0,
              enteredTaxableAmount: "",
            };
          } else if (field === "quantity") {
            updatedItem.quantity = value;
            const qty = parseFloat(value) || 0;
            const rate = parseFloat(updatedItem.rate) || 0;
            const gst = parseFloat(updatedItem.gst) || 0;
            const baseAmt = qty * rate;
            updatedItem.enteredTaxableAmount = baseAmt % 1 === 0 ? baseAmt.toString() : baseAmt.toFixed(2);
            updatedItem.taxableAmount = (baseAmt * (1 + gst / 100)).toFixed(2);
          } else if (field === "rate") {
            updatedItem.rate = value;
            const qty = parseFloat(updatedItem.quantity) || 0;
            const rate = parseFloat(value) || 0;
            const gst = parseFloat(updatedItem.gst) || 0;
            const baseAmt = qty * rate;
            updatedItem.enteredTaxableAmount = baseAmt % 1 === 0 ? baseAmt.toString() : baseAmt.toFixed(2);
            updatedItem.taxableAmount = (baseAmt * (1 + gst / 100)).toFixed(2);
          } else if (field === "gst") {
            updatedItem.gst = value;
            const baseAmt = parseFloat(updatedItem.enteredTaxableAmount) || 0;
            const gst = parseFloat(value) || 0;
            updatedItem.taxableAmount = (baseAmt * (1 + gst / 100)).toFixed(2);
          } else if (field === "enteredTaxableAmount") {
            updatedItem.enteredTaxableAmount = value;
            const inputVal = parseFloat(value) || 0;
            const rate = parseFloat(updatedItem.rate) || 0;
            const gst = parseFloat(updatedItem.gst) || 0;

            let calculatedQuantity = 0;
            if (rate > 0 && inputVal >= 0) {
              calculatedQuantity = inputVal / rate;
            }
            updatedItem.quantity = calculatedQuantity % 1 === 0 ? calculatedQuantity.toString() : calculatedQuantity.toFixed(2);

            const gstAmount = inputVal * (gst / 100);
            const total = inputVal + gstAmount;
            updatedItem.taxableAmount = total.toFixed(2);
          }

          return updatedItem;
        }
        return item;
      })
    );
  };

  const calculateGrandTotal = () => {
    return items.reduce(
      (sum, item) => sum + parseFloat(item.taxableAmount || 0),
      0
    );
  };

  // --- File Handlers ---
  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      if (selectedFile.size > 6 * 1024 * 1024) {
        toast.error("File size must be less than 6MB");
        event.target.value = "";
        return;
      }
      setFiles((prevFiles) => [
        ...prevFiles,
        { key: selectedFile.name, file: selectedFile }, // Use file name as key
      ]);
    }
    event.target.value = ""; // Allow reselecting the same file
  };

  const removeFile = (fileName) => {
    setFiles((prevFiles) =>
      prevFiles.filter((fileObj) => fileObj.key !== fileName)
    );
  };

  const handleDeleteDocument = (docId) => {
    const API = `${apiUrl?.delete_document}?documentId=${docId}`;
    callApi(API, { method: "GET" }).then((response) => {
      if (response?.status === true) {
        setExistingDocuments((prev) => prev.filter((doc) => doc.id !== docId));
        // toast.success(response.message);
      } else {
        toast.error(response?.message);
      }
    });
  };

  // Get the selected GST type
  const selectedGstType = watch("gstType");

  const selectedBudget = selectedExpenseHead
    ? expenseHeadList.find((head) => head?.expensehead?.id === selectedExpenseHead.id)
    : null;
  const availableBudget = selectedBudget
    ? (parseFloat(selectedBudget.originalAmount || 0) - parseFloat(selectedBudget.freezedAmount || 0))
    : 0;

  return (
    <>
      <div className="content container-fluid">
        <div className="content-head mb-5 d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center justify-content-start gap-4">
            <button
              role="button"
              className="btn back-arrow"
              onClick={() => navigate(-1)}
            >
              <BackArrowIcon />
            </button>
            <h1 className="mb-0">
              {location?.state?.data ? "Update" : "Create"} Payment Ticket -
              General
            </h1>
          </div>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label className="form-label" htmlFor="bDate">
                      Date
                    </label>
                    <Controller
                      name="date"
                      control={control}
                      rules={{
                        required: "This field is Required",
                      }}
                      defaultValue={moment().format("YYYY-MM-DD")}
                      render={({ field }) => (
                        <DatePicker size="sm"
                          {...field}
                          id="bDate"
                          format="dd/MM/yyyy"
                          oneTap
                          placeholder="dd/mm/yyyy"
                          style={{ width: "100%" }}
                          value={field.value ? new Date(field.value) : null}
                          onChange={(date) => {
                            field.onChange(date ? moment(date).format("YYYY-MM-DD") : "");
                          }}
                          cleanable={false}
                        />
                      )}
                    />
                    <ErrorMessage message={errors?.date?.message} />
                  </div>
                </div>

                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label className="form-label" htmlFor="expenseMonth">
                      Expense Month<span className="text-danger">*</span>
                    </label>
                    <Controller
                      name="expenseMonth"
                      control={control}
                      rules={{ required: "Expense Month is required" }}
                      defaultValue=""
                      render={({ field }) => (
                        <DatePicker size="sm"
                          {...field}
                          id="expenseMonth"
                          format="MM/yyyy"
                          oneTap
                          placeholder="MM/yyyy"
                          style={{ width: "100%" }}
                          value={field.value ? new Date(field.value) : null}
                          onChange={(date) => {
                            field.onChange(date ? moment(date).format("YYYY-MM") : "");
                          }}
                          cleanable={false}
                        />
                      )}
                    />
                    <ErrorMessage message={errors?.expenseMonth?.message} />
                  </div>
                </div>
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <Controller
                      name="siteId"
                      control={control}
                      rules={{ ...errorTypes.required("site") }}
                      render={({ field, fieldState }) => (
                        <SearchSelectInput
                          label="Site"
                          placeholder="Search Site"
                          value={state.siteName}
                          onSelect={(option) => {
                            field.onChange(option?.value);
                            setState((pre) => ({
                              ...pre,
                              siteId: option?.value,
                              sitesName: option?.label,
                            }));
                            const selectedSite =
                              userDetails?.type === 2
                                ? state?.OandMSites.find(
                                  (s) => s.site.id === option.value
                                )
                                : state.assignedSites.find(
                                  (s) => s.site.id === option.value
                                );
                            if (selectedSite) {
                              handleFinancialYearCalculation(selectedSite.site);
                            }
                            setItems([]); // Reset items
                            setItemsList([]); // Reset itemsList
                            setSelectedExpenseHead(null); // Reset head
                          }}
                          onBlur={field.onBlur}
                          errors={fieldState.error?.message}
                          options={
                            userDetails?.type === 2
                              ? state?.OandMSites
                              : state.assignedSites
                          }
                          onSearch={
                            userDetails?.type === 2
                              ? GetAllSitesList
                              : getAssignedSites
                          }
                          isLoading={state?.isLoadingSite}
                          showAddButton={false}
                          required={true}
                          disabled={items.length > 0 || location?.state?.data}
                        />
                      )}
                    />
                  </div>
                </div>
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label className="form-label">GST Type</label>
                    <select
                      className="form-select form-control"
                      aria-label="Default select example"
                      {...register("gstType", {
                        required: "Please select GST type",
                      })}
                      onChange={(event) => {
                        setState((prev) => ({
                          ...prev,
                          gstType: event?.target?.value,
                        }));
                      }}
                    >
                      <option value="" className="d-none">
                        Select GST Type
                      </option>
                      <option value={"IGST"}>IGST</option>
                      <option value={"CGST + SGST"}>CGST + SGST</option>
                    </select>
                    <ErrorMessage message={errors?.gstType?.message} />
                  </div>
                </div>

                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label className="form-label">
                      Financial Year<span className="text-danger">*</span>
                    </label>
                    <Controller
                      name="financialYear"
                      control={control}
                      rules={{ required: "Financial Year is required" }}
                      render={({ field }) => (
                        <select
                          className="form-select"
                          {...field}
                          onChange={(e) => {
                            field.onChange(e.target.value);
                            setActiveFinancialYear(e.target.value);
                          }}
                          disabled={!state.siteId || !!location?.state?.data}
                          value={activeFinancialYear}
                        >
                          <option value="" disabled>
                            Select Financial Year
                          </option>
                          {financialYears?.map((fy) => (
                            <option key={fy} value={fy}>
                              {fy}
                            </option>
                          ))}
                        </select>
                      )}
                    />
                    <ErrorMessage message={errors?.financialYear?.message} />
                  </div>
                </div>

                {/* === NEW DYNAMIC SECTION === */}
                <div className="col-12">
                  <hr />
                  <div className="card-box mb-3 card">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-12 col-md-6 col-lg-4">
                          <div className="form-group mb-3">
                            <label className="form-label d-flex justify-content-between align-items-center w-100">
                              <span>Expense Head</span>
                              {selectedExpenseHead && selectedBudget && (
                                <span className="text-success fs-6 fw-bold">
                                  Available Budget: ₹ {formatAmount(availableBudget)}
                                </span>
                              )}
                            </label>
                            <select
                              className="form-select form-control"
                              value={selectedExpenseHead?.id || ""}
                              onChange={handleExpenseHeadChange}
                              disabled={
                                !state.siteId ||
                                isExpenseListLoading ||
                                items.length > 0 || // Disable if items are added
                                location?.state?.data // Disable in edit mode
                              }
                            >
                              <option value="" disabled>
                                {isExpenseListLoading
                                  ? "Loading..."
                                  : "Select Expense Head"}
                              </option>
                              {expenseHeadList?.length > 0 ? (
                                expenseHeadList?.map((item) => (
                                  <option
                                    key={item?.expensehead?.id}
                                    value={item?.expensehead?.id}

                                  >
                                    {item?.expensehead?.name}
                                  </option>
                                ))
                              ) : (
                                <option value="" disabled>
                                  No data available
                                </option>
                              )}
                            </select>
                          </div>
                        </div>

                        {selectedExpenseHead && (
                          <div className="col-12">
                            <div className="d-flex justify-content-between align-items-center">
                              <h4 className="fs-3 rajdhani-semibold my-4">
                                Item Details
                              </h4>
                              <button
                                className="btn btn-outline-primary mx-2"
                                type="button"
                                onClick={addItem}
                                disabled={!selectedExpenseHead}
                              >
                                <PlusIcon /> Add Items
                              </button>
                            </div>

                            <div
                              className="table-responsive"
                              style={{
                                overflow: "visible",
                                minHeight: items.length > 0 ? "260px" : "auto",
                              }}
                            >
                              <table className="table mt-3">
                                <thead>
                                  <tr>
                                    <th style={{ width: "28%", minWidth: "220px" }}>Item <span className="text-danger">*</span></th>
                                    {/* <th style={{ width: "10%" }}>HSN Code</th> */}
                                    <th style={{ width: "15%", minWidth: "100px" }}>Qty <span className="text-danger">*</span></th>
                                    <th style={{ width: "15%", minWidth: "100px" }}>Rate <span className="text-danger">*</span></th>
                                    <th style={{ width: "10%", minWidth: "90px" }}>
                                      {/* {selectedGstType === "CGST + SGST" */}
                                      GST %{/* : "IGST %"} */}<span className="text-danger">*</span>
                                    </th>
                                    {/* {selectedGstType === "CGST + SGST" && (
                                      <>
                                        <th style={{ width: "8%" }}>CGST</th>
                                        <th style={{ width: "8%" }}>SGST</th>
                                      </>
                                    )} */}
                                    <th style={{ width: "12%", minWidth: "110px" }}>
                                      Taxable Amount
                                    </th>
                                    <th style={{ width: "13%", minWidth: "110px" }}>
                                      Total Amount <span className="text-danger">*</span>
                                    </th>
                                    <th style={{ width: "7%", minWidth: "60px" }}>Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {items.length === 0 ? (
                                    <tr>
                                      <td
                                        colSpan={7}
                                        className="text-center text-danger py-3"
                                      >
                                        No items added. Click "Add Items".
                                      </td>
                                    </tr>
                                  ) : (
                                    items.map((item, itemIndex) => {
                                      const optionsList =
                                        itemsList?.map((option) => ({
                                          value: option?.itemId,
                                          label: option?.item?.name || "",
                                          subLabel: option?.item?.hsnCode
                                            ? `HSN: ${option?.item?.hsnCode}`
                                            : undefined,
                                          disabled: items.some(
                                            (i, idx) =>
                                              i?.itemId === option?.itemId &&
                                              idx !== itemIndex
                                          ),
                                        })) || [];

                                      const selectedOption = itemsList?.find(
                                        (opt) => opt?.itemId === item?.itemId
                                      );

                                      const selectedLabel =
                                        selectedOption?.item?.name ||
                                        item?.name ||
                                        "";

                                      return (
                                        <tr key={itemIndex}>
                                          <td
                                            style={{
                                              position: "relative",
                                              zIndex: items.length - itemIndex + 10,
                                            }}
                                          >
                                            <SearchSelectInput
                                              label=""
                                              placeholder="Search Item..."
                                              value={selectedLabel}
                                              options={optionsList}
                                              onSelect={(option) => {
                                                handleItemChange(
                                                  itemIndex,
                                                  "itemId",
                                                  option?.value
                                                );
                                              }}
                                              showAddButton={false}
                                              className="mb-0"
                                            />
                                          </td>
                                          <td>
                                            <input
                                              type="number"
                                              onWheel={(e) => e.target.blur()}
                                              className="form-control"
                                              min={0}
                                              step="any"
                                              value={item.quantity || ""}
                                              onChange={(e) => {
                                                let value = e.target.value;
                                                if (!/^\d*(\.\d{0,2})?$/.test(value)) return;
                                                handleItemChange(itemIndex, "quantity", value);
                                              }}
                                              onBlur={(e) => {
                                                const value = parseFloat(e.target.value);
                                                if (!isNaN(value)) {
                                                  const formatted = value % 1 === 0 ? value.toString() : value.toFixed(2);
                                                  handleItemChange(itemIndex, "quantity", formatted);
                                                }
                                              }}
                                              disabled={!item.itemId}
                                              required
                                            />
                                          </td>
                                          <td>
                                            <input
                                              type="number"
                                              onWheel={(e) => e.target.blur()}
                                              className="form-control"
                                              min={0}
                                              step="any"
                                              value={item.rate || ""}
                                              onChange={(e) => {
                                                let value = e.target.value;
                                                if (!/^\d*(\.\d{0,2})?$/.test(value)) return;
                                                handleItemChange(itemIndex, "rate", value);
                                              }}
                                              onBlur={(e) => {
                                                const value = parseFloat(e.target.value);
                                                if (!isNaN(value)) {
                                                  const formatted = value % 1 === 0 ? value.toString() : value.toFixed(2);
                                                  handleItemChange(itemIndex, "rate", formatted);
                                                }
                                              }}
                                              disabled={!item.itemId}
                                              required
                                            />
                                          </td>
                                          <td>
                                            <select
                                              className="form-select form-control"
                                              value={item.gst || 0}
                                              onChange={(e) => {
                                                handleItemChange(itemIndex, "gst", e.target.value);
                                              }}
                                              disabled={!item.itemId}
                                            >
                                              <option value="0">0%</option>
                                              <option value="5">5%</option>
                                              <option value="12">12%</option>
                                              <option value="18">18%</option>
                                              <option value="28">28%</option>
                                            </select>
                                          </td>
                                          <td>
                                            <input
                                              type="number"
                                              onWheel={(e) => e.target.blur()}
                                              className="form-control"
                                              min={0.01}
                                              step="any"
                                              value={item.enteredTaxableAmount || ""}
                                              onChange={(e) => {
                                                let value = e.target.value;
                                                if (!/^\d*(\.\d{0,2})?$/.test(value)) return;
                                                if (value.startsWith(".")) value = "0" + value;
                                                handleItemChange(itemIndex, "enteredTaxableAmount", value);
                                              }}
                                              onBlur={(e) => {
                                                const value = parseFloat(e.target.value);
                                                if (!isNaN(value)) {
                                                  handleItemChange(itemIndex, "enteredTaxableAmount", value.toFixed(2));
                                                }
                                              }}
                                              disabled={true}
                                              required
                                            />
                                          </td>
                                          <td>
                                            {formatAmount(
                                              item.taxableAmount || 0
                                            )}
                                          </td>
                                          <td>
                                            <button
                                              className="btn btn-outline-danger"
                                              type="button"
                                              onClick={() =>
                                                removeItem(itemIndex)
                                              }
                                            >
                                              <DeleteIcon />
                                            </button>
                                          </td>
                                        </tr>
                                      );
                                    })
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Removed Add Section Button */}
                </div>

                {calculateGrandTotal() > 0 && (
                  <div className="mt-4">
                    <h3 className="text-success">
                      Grand Total:{" "}
                      {formatAmount(calculateGrandTotal().toFixed(2))}
                    </h3>
                  </div>
                )}

                <div className="row my-4">
                  <div className="col-12 col-md-6 col-lg-4">
                    <div className="form-group mb-3">
                      <label className="form-label" htmlFor="bDate">
                        Benificiary Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Name"
                        id="name"
                        {...register("name", {
                          required: "Benificiary Name is Required",
                        })}
                      />
                      <ErrorMessage message={errors?.name?.message} />
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-lg-4">
                    <div className="form-group mb-3">
                      <label htmlFor="MobileNO" className="form-label">
                        Mobile No. <span className="text-danger">*</span>
                      </label>
                      <input
                        type="tel"
                        className="form-control"
                        placeholder="Mobile No."
                        id="MobileNO"
                        {...register("phone", {
                          required: "Mobile Number is required",
                          pattern: {
                            value: /^[0-9]{10}$/,
                            message: "Mobile number must be exactly 10 digits",
                          },
                        })}
                        onInput={(e) => {
                          e.target.value = e.target.value
                            .replace(/[^0-9]/g, "")
                            .slice(0, 10);
                        }}
                      />
                      <ErrorMessage message={errors?.phone?.message} />
                    </div>
                  </div>

                  <div className="col-12 col-md-6 col-lg-4">
                    <div className="form-group mb-3">
                      <label htmlFor="accountHolderName" className="form-label">
                        Account Holder Name
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="holderName"
                        placeholder="Account Holder Name"
                        {...register("accountHolderName", {
                          ...errorTypes.required("Account holder name"),
                        })}
                      />
                      <ErrorMessage
                        message={errors?.accountHolderName?.message}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-lg-4">
                    <div className="form-group mb-3">
                      <label htmlFor="accountNumber" className="form-label">
                        Account Number<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="accountNumber"
                        placeholder="Account Number"
                        {...register("accountNumber", {
                          ...errorTypes.required("Account number"),
                        })}
                        onChange={(e) => {
                          e.target.value = e.target.value
                            .replace(/[^0-9.]/g, "") // Remove everything except numbers and dot
                            .replace(/^(\.)+/, "") // Prevent dot at the start
                            .replace(/(\..*)\./g, "$1"); // Prevent multiple dots
                        }}
                      />
                      <ErrorMessage message={errors?.accountNumber?.message} />
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-lg-4">
                    <div className="form-group mb-3">
                      <label htmlFor="ifscCode" className="form-label">
                        IFSC Code<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="ifscCode"
                        placeholder="IFSC Code"
                        maxLength={11}
                        {...register("ifscCode", {
                          ...errorTypes.required("IFSC code"),
                          pattern: {
                            value: /^[A-Z0-9]*$/,
                            message: "It must contain only numbers and letters",
                          },
                          onChange: (e) => {
                            e.target.value = e.target.value.toUpperCase();
                            if (e.target.value.length === 11) {
                              fetchBankDetails(e.target.value);
                            } else {
                              setValue("bankName", "");
                              setValue("branchName", "");
                            }
                          }
                        })}
                      />
                      <ErrorMessage message={errors?.ifscCode?.message} />
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-lg-4">
                    <div className="form-group mb-3">
                      <label htmlFor="bankName" className="form-label">
                        Bank Name<span className="text-danger">*</span>
                      </label>
                      <div className="input-group mb-3 DatePicker">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Bank Name"
                          {...register("bankName", {
                            ...errorTypes.required("Bank Name"),
                          })}
                          disabled={isLoadingBankData || true}
                        />
                      </div>
                      <ErrorMessage message={errors?.bankName?.message} />
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-lg-4">
                    <div className="form-group mb-3">
                      <label htmlFor="accountNumber" className="form-label">
                        Branch Name<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="branchName"
                        placeholder="branchName"
                        {...register("branchName", {
                          ...errorTypes.required("Branch name"),
                        })}
                        disabled={isLoadingBankData || true}
                      />
                      <ErrorMessage message={errors?.branchName?.message} />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12 " />
                  <div className="col-12 col-md-6 col-lg-5">
                    <div className="form-group mb-3">
                      <label className="form-label" htmlFor="ref">
                        Upload Bills
                      </label>
                      <input
                        type="file"
                        className="form-control d-none"
                        id="documentUpload"
                        accept="image/*,application/pdf"
                        onChange={handleFileChange}
                      />
                      <label
                        htmlFor="documentUpload"
                        className="form-label rounded-4 cursor-pointer d-flex align-items-center justify-content-center"
                        style={{
                          display: "inline-block",
                          cursor: "pointer",
                          padding: 5,
                          backgroundColor: "rgb(245, 245, 245)",
                          borderRadius: 8,
                          minWidth: 150,
                        }}
                      >
                        <div className="d-flex flex-column">
                          <span className="placeholder-img">
                            <UploadPlusIcon />
                          </span>
                          <span className="text-muted">Choose Files </span>
                        </div>
                      </label>
                      <div className="preview-section p-1 mt-3" />
                    </div>
                  </div>
                </div>
                {/* File Preview Section */}
                <div className="preview-section p-1 mt-3 col-lg-5">
                  {files?.length > 0 &&
                    files.map((fileObj) => (
                      <div
                        key={fileObj.key} // Using file name as key
                        className="d-flex align-items-center justify-content-between p-1 border rounded mb-2"
                        style={{
                          backgroundColor: "#f8f9fa",
                          cursor: "pointer",
                        }}
                      >
                        <div
                          className="w-100"
                          onClick={() => {
                            setSelectedDocument(fileObj?.file);
                            toggleModal();
                          }}
                        >
                          <span className="fs-5">{fileObj?.file?.name}</span>
                        </div>
                        <button
                          type="button"
                          className="text-danger mx-2 bg-light"
                          onClick={() => removeFile(fileObj.key)} // Remove using file name
                        >
                          <DeleteIcon />
                        </button>
                      </div>
                    ))}

                  {existingDocuments?.length > 0 &&
                    existingDocuments.map((doc) => (
                      <div
                        key={doc.id}
                        className="d-flex align-items-center justify-content-between p-1 border rounded mb-2"
                        style={{
                          backgroundColor: "#f8f9fa",
                          cursor: "pointer",
                        }}
                      >
                        <div
                          className="w-100"
                          onClick={() => {
                            const docUrl = {
                              url: doc?.url,
                            };
                            setSelectedDocument(docUrl);
                            toggleModal();
                          }}
                        >
                          <span className="fs-5">{doc?.name}</span>
                        </div>
                        <button
                          type="button"
                          className="text-danger mx-2 bg-light"
                          onClick={() => handleDeleteDocument(doc.id)}
                        >
                          <DeleteIcon />
                        </button>
                      </div>
                    ))}
                </div>

                {/* <div className="col-12 col-md-6 col-lg-8 w-100">
                  <div className="form-group mb-3">
                    <label htmlFor="desc" className="form-label">
                      Description
                    </label>
                    <textarea
                      className="form-control "
                      id="desc"
                      rows="3"
                      {...register("description")}
                    />
                  </div>
                </div> */}

                <div className="col-12 ">
                  <div className="form-group mb-3">
                    <label htmlFor="totalLeavePerMonth" className="form-label">
                      Description
                      {/* <span className="text-danger">*</span> */}
                    </label>
                    <Controller
                      name="content"
                      control={control}
                      rules={
                        {
                          // required: "Description is required",
                        }
                      }
                      render={({ field }) => (
                        <div>
                          <CKEditor
                            {...field}
                            editor={ClassicEditor}
                            data={field.value || ""}
                            onChange={(event, editor) => {
                              field.onChange(editor.getData());
                            }}
                            config={{
                              toolbar: [
                                "heading",
                                "|",
                                "bold",
                                "italic",
                                "underline",
                                "strikethrough",
                                "|",
                                "fontColor",
                                "fontBackgroundColor",
                                "fontFamily",
                                "fontSize",
                                "alignment",
                                "|",
                                "link",
                                "bulletedList",
                                "numberedList",
                                "blockQuote",
                                "undo",
                                "redo",
                              ],
                              image: {
                                toolbar: [
                                  "imageStyle:alignLeft",
                                  "imageStyle:alignCenter",
                                  "imageStyle:alignRight",
                                  "|",
                                  "imageTextAlternative",
                                ],
                              },
                              height: "500px",
                            }}
                          />
                          <ErrorMessage message={errors?.content?.message} />
                        </div>
                      )}
                    />
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-end">
                <button
                  disabled={isLoading}
                  type="submit"
                  className="btn btn-primary px-5"
                >
                  {isLoading ? <Spinner /> : EditData ? "Update" : "Create"}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
      <ViewDocumentModal
        modal={modal}
        toggle={toggleModal}
        selectedDocument={selectedDocument}
      />
    </>
  );
}
